import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import {
  fetchDataByQuery,
  fetchDataByRawQuery,
} from "../../../service/dataExport";
import { allCvReport } from "../../../static/reportQuery";

const ApsTable = ({
  apsAllReport,
  apsAllLoading,
  apsFilledLoading,
  apsFilledReport,
  apsReviewedReport,
  apsReviewedLoading,
}) => {
  const hasApsrData =
    apsAllReport &&
    typeof apsAllReport === "object" &&
    Object.keys(apsAllReport).length > 0;
  const hasApsFilledData =
    Array.isArray(apsFilledReport) && apsFilledReport.length > 0;
  const hasApsReviewedData =
    Array.isArray(apsReviewedReport) && apsReviewedReport.length > 0;

  const getApsQuery = (query) => {
    const ststatusCase =
      "CASE WHEN s.ststatus = 0 THEN 'Active' WHEN s.ststatus = 1 THEN 'Hold' WHEN s.ststatus = 2 THEN 'Drop' WHEN s.ststatus = 3 THEN 'Alumni' WHEN s.ststatus = 4 THEN 'In-Active' WHEN s.ststatus = 5 THEN 'Admission Defered' WHEN s.ststatus = 6 THEN 'Defered Active' WHEN s.ststatus = 7 THEN 'Ref/VIP' WHEN s.ststatus = 8 THEN 'Refund' WHEN s.ststatus = 9 THEN 'Hold - Not Eligible' WHEN s.ststatus = 10 THEN 'Hold - Payment Pending' WHEN s.ststatus = 11 THEN 'Hold - Not Responding' WHEN s.ststatus = 12 THEN 'Hold - Not Approved' ELSE 'NA' END AS Status";
    return `SELECT DISTINCT s.Stdid AS 'Student Id', s.StdName AS 'Student Name', i.intakeName AS 'Intake', ${ststatusCase}, lo.locname AS 'Location', ct.catname AS 'Category', s.PaymentStatus AS 'Payment Status', v.ApsStatus, v.Apspayment, cm.Compname AS 'APS Category', cm1.Compname AS 'APS Form Status', cm2.Compname AS 'Academic Status', v.ApsReviewedby, v.Apsfilledby FROM StudentMas s LEFT JOIN VisaMasNew v ON s.StdCode = v.StdCode JOIN intakemas i ON i.intakeCode = s.intakeCode JOIN catmas ct ON ct.catCode = s.catCode JOIN locmas lo ON lo.locCode = s.locCode JOIN commontypemas cm ON cm.compid = v.ApsCategory JOIN commontypemas cm1 ON cm1.compid = v.Apsformstatus JOIN commontypemas cm2 ON cm2.compid = v.Acadmicstatuscode WHERE ${query}`;
  };
  return (
    <div className="container-fluid">
      <div className="container-sm">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="">
              
            </div>
          </div>
        </div>
      </div>
      <div className="container-sm py-3">
        <div className="row mb-3 justify-content-center">
          <div className="col-md-6 flex-vh-center">
            <div className="card w-50 border-warning">
              <div className="card-body">
                <div className="d-flex flex-column justify-content-between align-items-center">
                  <span className="fw-bold fs-6">APS Not Applied</span>
                  <span
                    className="fs-5 cursor-pointer"
                    onClick={() =>
                      fetchDataByQuery(
                        apsAllReport.totalApsNotApplied?.query,
                        allCvReport?.apsReport,
                        "Confirm to download .csv file"
                      )
                    }
                  >
                    {apsAllReport?.totalApsNotApplied?.count}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 flex-vh-center">
            <div className="card w-50 border-warning">
              <div className="card-body">
                <div className="d-flex flex-column justify-content-between align-items-center">
                  <span className="fw-bold fs-6">APS Applied</span>
                  <span
                    className="fs-5"
                    onClick={() =>
                      fetchDataByQuery(
                        apsAllReport.totalApsApplied?.query,
                        allCvReport?.apsReport,
                        "Confirm to download .csv file"
                      )
                    }
                  >
                    {apsAllReport?.totalApsApplied?.count}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-sm">
        <div className="row justify-content-center">
            <div className="col-md-4">
              <div className="funnel"></div>
            </div>
        </div>
      </div>
      <div className="row">
        {!apsAllLoading ? (
          <div className="card mb-3 col-md-4">
            <div className="card-body">
              <div>
                <div
                  className="overflow-auto wb-scrollbar-w-1 mb-3"
                  style={{ maxHeight: "50vh" }}
                >
                  {hasApsrData ? (
                    <table className="table table-yesgermany table-hover table-bordered">
                      <thead className="sticky-top">
                        <tr className="text-nowrap">
                          <th>APS Status</th>
                          <th>Counts</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Total Students</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.total_students?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.total_students?.count}
                          </td>
                        </tr>
                        <tr>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.not_updated?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            Not Updated
                          </td>
                          <td>{apsAllReport?.not_updated?.count}</td>
                        </tr>
                        <tr>
                          <td>APS Not Started</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.aps_not_started?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.aps_not_started?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>Intro APS Email</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.intro_aps_call_done?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.intro_aps_call_done?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>APS/Visa Form Recieved</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.form_recieved?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.form_recieved?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>APS Form Filled</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.form_filled?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.form_filled?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>APS Form Completed & Checklist Sent</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.form_completed?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.form_completed?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>Final File Recieved & Verified</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.final_file_recieved?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.final_file_recieved?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>Document Sent to APS</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.doc_sent_to_aps?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.doc_sent_to_aps?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>APS Certificate Follow-up</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.aps_followup?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.aps_followup?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>APS Recieved & Uploaded on dropbox</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.uploaded_on_dropbox?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.uploaded_on_dropbox?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>APS Recieved (Self Applied)</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.aps_recieved_self?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.aps_recieved_self?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>Foriegn Degree</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.foreign_degree?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.foreign_degree?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>Not Applicable</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.not_applicable?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.not_applicable?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>Pursuing 12th</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.pursuing?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.pursuing?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>Rejection</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.rejection?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.rejection?.count}
                          </td>
                        </tr>
                        <tr>
                          <td>Self Applied</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                apsAllReport.self_applied?.query,
                                allCvReport?.apsReport,
                                "Confirm to download .csv file"
                              )
                            }
                            className="cursor-pointer"
                          >
                            {apsAllReport?.self_applied?.count}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ) : (
                    <p>No data available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="py-3">
            <SkeletonTheme highlightColor="#fff3cd">
              <Skeleton height={70} style={{ marginBottom: "10px" }} />
            </SkeletonTheme>
          </div>
        )}

        {!apsFilledLoading ? (
          <div className="card mb-3 col-md-4">
            <div className="card-body">
              <div>
                <div
                  className="overflow-auto wb-scrollbar-w-1 mb-3"
                  style={{ maxHeight: "50vh" }}
                >
                  {hasApsFilledData ? (
                    <table className="table table-yesgermany table-hover table-bordered">
                      <thead className="sticky-top">
                        <tr className="text-nowrap">
                          <th>APS Filled by</th>
                          <th>Counts</th>
                        </tr>
                      </thead>
                      <tbody>
                        {apsFilledReport?.map((item, idx) => (
                          <tr key={idx}>
                            <td>{item.APSFILLEDBY || "Not Updated"}</td>
                            <td
                              onClick={() =>
                                fetchDataByRawQuery(
                                  getApsQuery(
                                    `v.Apsfilledby = '${item.APSFILLEDBY}'`
                                  ),
                                  "Confirm to download .csv file"
                                )
                              }
                              className="cursor-pointer"
                            >
                              {item.Column1}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>No data available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="py-3">
            <SkeletonTheme highlightColor="#fff3cd">
              <Skeleton height={70} style={{ marginBottom: "10px" }} />
            </SkeletonTheme>
          </div>
        )}
        {!apsReviewedLoading ? (
          <div className="card mb-3 col-md-4">
            <div className="card-body">
              <div>
                <div
                  className="overflow-auto wb-scrollbar-w-1 mb-3"
                  style={{ maxHeight: "50vh" }}
                >
                  {hasApsReviewedData ? (
                    <table className="table table-yesgermany table-hover table-bordered">
                      <thead className="sticky-top">
                        <tr className="text-nowrap">
                          <th>APS Reviewed by</th>
                          <th>Counts</th>
                        </tr>
                      </thead>
                      <tbody>
                        {apsReviewedReport?.map((item, idx) => (
                          <tr key={idx}>
                            <td>{item.APSREVIEWEDBY || "Not Updated"}</td>
                            <td
                              onClick={() =>
                                fetchDataByRawQuery(
                                  getApsQuery(
                                    `v.ApsReviewedby = '${item.APSREVIEWEDBY}'`
                                  ),
                                  "Confirm to download .csv file"
                                )
                              }
                              className="cursor-pointer"
                            >
                              {item.Column1}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>No data available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="py-3">
            <SkeletonTheme highlightColor="#fff3cd">
              <Skeleton height={70} style={{ marginBottom: "10px" }} />
            </SkeletonTheme>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApsTable;
